/* Movilo — hero verb cycle and lineup quick add */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- hero */
  function initHero(hero) {
    if (hero.dataset.mvReady) return;
    hero.dataset.mvReady = '1';

    var verbs = Array.prototype.slice.call(hero.querySelectorAll('[data-mv-verb]'));
    var stages = Array.prototype.slice.call(hero.querySelectorAll('[data-mv-stage]'));
    if (!verbs.length) return;

    var interval = parseInt(hero.dataset.mvInterval, 10) || 3500;
    var current = 0;
    var timer = null;
    var hovering = false;
    var visible = true;

    function show(index) {
      current = index;
      hero.setAttribute('data-material', verbs[index].getAttribute('data-mv-material') || '');
      verbs.forEach(function (v, i) {
        var on = i === index;
        if (on) {
          // restart the progress bar animation
          v.classList.remove('is-active');
          void v.offsetWidth;
        }
        v.classList.toggle('is-active', on);
      });
      stages.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (reduceMotion || hovering || !visible || verbs.length < 2) return;
      hero.classList.remove('is-paused');
      timer = setInterval(function () {
        show((current + 1) % verbs.length);
      }, interval);
    }

    function pause() {
      hovering = true;
      hero.classList.add('is-paused');
      stop();
    }

    function resume() {
      hovering = false;
      start();
    }

    verbs.forEach(function (v, i) {
      v.addEventListener('mouseenter', function () { show(i); pause(); });
      v.addEventListener('focus', function () { show(i); pause(); });
    });

    var copy = hero.querySelector('.mv-hero__verbs');
    var stage = hero.querySelector('.mv-hero__stage');
    [copy, stage].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseleave', resume);
      el.addEventListener('focusout', function (e) {
        if (!el.contains(e.relatedTarget)) resume();
      });
    });
    if (stage) stage.addEventListener('mouseenter', pause);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start();
        else stop();
      }).observe(hero);
    }

    if (reduceMotion) hero.classList.add('is-paused');
    show(0);
    start();
  }

  /* ----------------------------------------------------------- quick add */
  function initQuickAdd(root) {
    (root || document).querySelectorAll('[data-mv-quickadd]').forEach(function (form) {
      if (form.dataset.mvReady) return;
      form.dataset.mvReady = '1';

      form.addEventListener('submit', function (e) {
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return; // fall back to a normal post

        e.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        var label = form.querySelector('[data-mv-label]');
        var original = label ? label.textContent : '';
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');

        var body = new FormData(form);
        if (typeof cart.getSectionsToRender === 'function') {
          body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          body.append('sections_url', window.location.pathname);
        }
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

        var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (label) label.textContent = res.description || res.message || 'Could not add';
              return;
            }
            cart.renderContents(res);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            button.classList.add('is-added');
            if (label) label.textContent = 'Added';
            setTimeout(function () {
              button.classList.remove('is-added');
              if (label) label.textContent = original;
            }, 2200);
          })
          .catch(function () { form.submit(); })
          .finally(function () { button.removeAttribute('aria-busy'); });
      });
    });
  }

  /* ------------------------------------------------- product gallery */
  function initGallery(gallery) {
    if (gallery.dataset.mvReady) return;
    gallery.dataset.mvReady = '1';

    var track = gallery.querySelector('[data-mv-track]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-mv-thumb]'));
    if (!track || !thumbs.length) return;

    function mark(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' });
        mark(i);
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
        ticking = false;
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var i = Math.round(track.scrollLeft / track.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1);
      i = Math.max(0, Math.min(thumbs.length - 1, i));
      thumbs[i].click();
    });
  }

  /* --------------------------------------------- phone add-to-cart bar */
  function initStickyBar(pdp) {
    var bar = pdp.querySelector('[data-mv-stickybar]');
    var main = pdp.querySelector('[data-mv-main-add]');
    if (!bar || !main || bar.dataset.mvReady || !('IntersectionObserver' in window)) return;
    bar.dataset.mvReady = '1';

    // Show the bar whenever the main add button is off screen — above it
    // (scrolled past) or below it (short phones) — so a buy button is always in view.
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('mv-bar-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = bar.querySelector('button');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }).observe(main);
  }

  /* --------------------------------------------- Buy 1 / Buy 2 offer: keep the phone bar price in step */
  function initOffers(pdp) {
    var offers = pdp.querySelector('[data-mv-offers]');
    var price = pdp.querySelector('[data-mv-sticky-price]');
    if (!offers || !price || offers.dataset.mvReady) return;
    offers.dataset.mvReady = '1';
    offers.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.dataset.price) return;
      price.textContent = input.dataset.price + ' ';
      if (input.dataset.was) {
        var was = document.createElement('s');
        was.textContent = input.dataset.was;
        price.appendChild(was);
      }
    });
  }

  /* ------------------------------------- product card photo strip */
  function initCard(card) {
    if (card.dataset.mvReady) return;
    card.dataset.mvReady = '1';

    var track = card.querySelector('[data-mvc-track]');
    var dots = Array.prototype.slice.call(card.querySelectorAll('.mvc__dot'));
    var prev = card.querySelector('[data-mvc-step="-1"]');
    var next = card.querySelector('[data-mvc-step="1"]');
    if (!track || !dots.length) return;
    var count = dots.length;

    function index() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }
    function mark() {
      var i = Math.max(0, Math.min(count - 1, index()));
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === count - 1;
    }
    function go(step) {
      var i = Math.max(0, Math.min(count - 1, index() + step));
      track.scrollTo({ left: track.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        go(parseInt(btn.getAttribute('data-mvc-step'), 10));
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { mark(); ticking = false; });
    }, { passive: true });

    // A horizontal swipe on the photos must not also open the product
    var startX = 0;
    var moved = false;
    track.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
    track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - startX) > 8) moved = true; });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } });
  }

  /* --------------------------------- product variant buttons (colours) */
  function initVariants(pdp) {
    var box = pdp.querySelector('[data-mv-variants]');
    if (!box || box.dataset.mvReady) return;
    box.dataset.mvReady = '1';
    var name = box.querySelector('[data-mv-variant-name]');
    var now = pdp.querySelector('.mv-pdp__now');
    var sticky = pdp.querySelector('[data-mv-sticky-price]');

    // A link to a specific colour (?variant=) opens on that colour's photo
    var picked = box.querySelector('input:checked');
    var track = pdp.querySelector('[data-mv-track]');
    if (picked && picked.dataset.slide && /[?&]variant=/.test(window.location.search) && track) {
      track.scrollLeft = track.clientWidth * parseInt(picked.dataset.slide, 10);
    }

    box.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.name !== 'id') return;
      if (name) name.textContent = input.dataset.title || '';
      if (now && input.dataset.price) now.textContent = input.dataset.price;
      if (sticky && input.dataset.price) sticky.textContent = input.dataset.price;
      var thumb = input.dataset.slide && pdp.querySelector('[data-mv-thumb="' + input.dataset.slide + '"]');
      if (thumb) thumb.click();
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* old browsers: keep the URL */ }
    });
  }

  /* ------------------------------------------- category sort select */
  function initSort(form) {
    if (form.dataset.mvReady) return;
    form.dataset.mvReady = '1';
    var select = form.querySelector('select');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-mvc]').forEach(initCard);
    scope.querySelectorAll('[data-mv-sort]').forEach(initSort);
    scope.querySelectorAll('[data-mv-hero]').forEach(initHero);
    scope.querySelectorAll('[data-mv-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-mv-pdp]').forEach(initStickyBar);
    scope.querySelectorAll('[data-mv-pdp]').forEach(initOffers);
    scope.querySelectorAll('[data-mv-pdp]').forEach(initVariants);
    initQuickAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
